import { Layout, message, Table,Carousel,Modal } from 'antd';
import React , {useState,useEffect }from 'react'
import './detail.css';
import {getCaseDetail,makeScore,viewAttach,getConfig} from './service';
import {RandomKey} from '../../utils/global';
import {getCatch,doLogout} from '../../utils/auth';
import { useLocation } from 'react-router-dom'; 
import Slider from 'react-slick'; 
import 'slick-carousel/slick/slick.css';  
import 'slick-carousel/slick/slick-theme.css';  
import { encode } from 'querystring';

const { Header, Content, Footer } = Layout;

const Detail = props => {
  const location = useLocation(); 
  const LOGINNAME = getCatch("name");
  const scrheight = document.body.clientHeight;

  const [CASEINFO, setCaseinfoElements] = useState('');  
  const [SCORESTANDARD, setScoreStandardElements] = useState(''); 
  const [PICLIST, setPiclistElements] = useState(''); 
  const [STANDARD, setStandardElements] = useState(''); 
  const [PICBTNLIST, setPicbtnlistElements] = useState(''); 
  const [PDFLIST, setPdflistElements] = useState(''); 
  const [LOGO, setLogoElements] = useState(''); 

  const settings = {  
        dots: true,//是否显示小圆点索引
        autoplay: true,//是否自动播放
        infinite: true,//是否无限循环
        autoplaySpeed: 3000,//自动播放的时间
        fade: true,//是否采用淡入淡出的效果
        slidesToShow: 1,
        slidesToScroll: 1
  }; 

  let _SCORE = [];

  let _JUDGED = false;

  let attach_piclist = [];


  let data = [
    // {title:"创新性  (40%)",content:"述案例描述案例描述案例描"},
    // {title:"创新性  (30%)",content:"述案例描述案例描述案例描"},
  ];

  let columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      width:'20%',
    },
    {
      title: 'Content',
      dataIndex: 'content',
      align:"left"
    }
  ];


    

  // 页面初始化
  useEffect(() => {
    dogetConfig();
    scoreStandard();
  }, []);

  const dogetConfig = async() => {
    var param = {"f":"J_getConfig","p":{}};
    return await getConfig(param).then((res) => {
      console.log(res);
      if(res.c != 0){
        var url = '../../img/TopDigitalLogo.png';
      }
      else{
        var url = res.d.config.judgelogo;
      }
      setLogoElements([...LOGO, url]);

    })
  }
  const showConfirm = (jtype) => {  
    if(_JUDGED){
      Modal.confirm({  
        title: '确认',  
        content: '该作品您已评分，是否要重置分数与点评?',  
        onOk: () => doscore(jtype),  
        onCancel: () => console.log('用户取消了'),  
      });  
    }
    else{
      doscore(jtype);
    }
  }  

  const doscore = (jtype)=>{
    let params = new URLSearchParams(location.search);
    let id = params.get("id");
    let ele = document.getElementById("comment");
    let score = [];
    if(jtype == 1){
      for(let i = 0;i < _SCORE.length;i++){
        score.push([_SCORE[i].review,_SCORE[i].myscore]);
      }
    }
    else if(jtype == 2){
      for(let i = 0;i < _SCORE.length;i++){
        if(_SCORE[i].myscore  !== ""){
          score.push([_SCORE[i].review,_SCORE[i].myscore]);
        }
      }
    }
    else{
      return;
    }
    if(score.length == 0){
      return;
    }
    score = Object.fromEntries(score); 
    var param = {};
    param.f = 'J_caseScore';
    param.p = {};
    param.p.token = getCatch("token");
    param.p.caseid = id;
    param.p.score = score;
    try{
      param.p.comment = ele.value;
    }catch(e){
      param.p.comment = "";
    }
    param.p.lastscore = document.getElementById("score").innerHTML;
    param = JSON.stringify(param);
    console.log(param);
    makeScore(param).then((res) => {
      console.log(res);
      if(res.c !== 0){
        message.error(res.m);
        return;
      }
      else{
        // message.success("评分成功");
        // setTimeout(function(){window.open("./#/list")},1000);
        showconfirmbox();
      }
    })
  }
  const score = (type,score,jtype)=>{
    
    let myscore = 0.0;
    if(jtype == 1){
      for(let i = 0;i < _SCORE.length;i++){
        if(_SCORE[i].review === type){
          _SCORE[i].myscore = score;
        }
      }
      for(let i = 0;i < _SCORE.length;i++){
        myscore += _SCORE[i]['myscore'] * _SCORE[i]['weight'] / 100;
      }
      myscore = myscore.toFixed(1);
    }
    if(jtype == 2){
      for(let i = 0;i < _SCORE.length;i++){
        if(_SCORE[i].review === type){
          _SCORE[i].myscore = score;
        }
        else{
          _SCORE[i].myscore = "";
        }
      }
      myscore = score;
    }
    document.getElementById("score").innerHTML = myscore;
  }

  const scoreStandard = async() => {
    let params = new URLSearchParams(location.search);
    let id = params.get("id");
    var param = {"f":"J_getScoreStanderd","p":{"token":getCatch("token"),"caseid":id}};
    return await getCaseDetail(param).then((res) => {
      if(res.c != 0){
        message.error(res.m);
        return;
      }
      console.log("scorestandard");
      console.log(res);
      //渲染评审UI
      let ele = [];
      _SCORE = res.d.list;
      if(res.d.judgetype == 1 || res.d.judgetype == 2){
        //初始化评分
        for(let i = 0;i < _SCORE.length;i++){
          _SCORE[i]['myscore'] = parseInt(_SCORE[i].max);
        }
        ele.push(scoretemplate(res.d.list,res.d.judgetype));
      }
      else if(res.d.judgetype == 3 || res.d.judgetype == 4){
        //初始化投票
        for(let i = 0;i < _SCORE.length;i++){
          _SCORE[i]['myscore'] = "";
        }
        ele.push(votetemplate(res.d.list,res.d.judgetype));
      }
      else{
        ele.push(<div key={RandomKey()}>未设置评审等级</div>);
      }
      setScoreStandardElements([...SCORESTANDARD, ele]);

      //初始化分数


      if(res.d.list.length > 0){
        for(let i = 0;i < res.d.list.length;i++){
          if(res.d.judgetype == 1 || res.d.judgetype == 2){
            data.push({title:res.d.list[i].review+"  ("+res.d.list[i].weight+"%)",content:res.d.list[i].desc,key: RandomKey() });
          }
          else{
            data.push({title:res.d.list[i].review+"  ("+res.d.list[i].score+")",content:res.d.list[i].desc ,key: RandomKey() });
          }
        }
      }
      else{
        // document.getElementById("standardbox").style.display="none";
        columns = [
          {
            title: 'Title',
            dataIndex: 'title',
            width:'100%',
            className:"tablestyle"
          }
        ];
        data.push({title:"未设置评审指标"});
      }

      setTimeout(function(){
        caseDetail();
      },300);

      
    })
  }

  const scoretemplate = (standardlist,judgetype)=>{
    let standard = [];
    let standard_sel = [];
    let subscore = [];
    let commentbox = [];

    let cellwidth = Math.floor(100/standardlist.length) + '%';

    let allscore = 0;
    let allscore_avg = 0;

    if(standardlist.length > 0){
      for(let i = 0;i < standardlist.length;i++){
        subscore = [];
        for(let k = parseInt(standardlist[i].max);k >= parseInt(standardlist[i].min);k--){
          if(k === parseInt(standardlist[i].max)){
            allscore += parseInt(standardlist[i].max);
            subscore.push(<div key={RandomKey()} style={{width:"100%",textAlign:"center"}}><input type="radio" defaultChecked onClick={()=>{score(standardlist[i].review,k,1)}}   className="radio-radio" name={standardlist[i].review} value={k} />&nbsp;<b> {k}分</b></div>);
          }
          else{
            subscore.push(<div key={RandomKey()} style={{width:"100%",textAlign:"center"}}><input type="radio" onClick={()=>{score(standardlist[i].review,k,1)}} className="radio-radio" name={standardlist[i].review} value={k} />&nbsp;<b> {k}分</b></div>);
          }
        }
        standard.push(<span style={{width:cellwidth}} key={RandomKey()}><b>*{standardlist[i].review}</b><small>所占权重{standardlist[i].weight}%</small></span>);
        standard_sel.push(<div className="radio" style={{width:cellwidth}} key={RandomKey()}>{[subscore]}</div>);
      }
      allscore_avg = (allscore/standardlist.length).toFixed(1);

      if(judgetype == 2){
        commentbox.push(<div key={RandomKey()} style={{width:"100%",textAlign:"center",marginTop:"15px"}}><div style={{width:"100%",height:"30px",lineHeight:"30px",textAlign:"left",fontSize:"15px",fontWeight:"bold",marginLeft:"10px"}}>点评</div><textarea id="comment" rows="3" cols="90" style={{width:"100%"}}></textarea></div>);
      }
        return (
          <div key={RandomKey()}>
            <div className="hh" style={{border:"none"}}>评分</div>
              <div className="raterDiv">
                <div id="standard">
                  {[standard]}
                </div>
              </div>
              <div>
                <div className="raterDiv-bottom">
                  <div id="standard_sel">
                    {[standard_sel]}
                  </div>
                  
                  <div className="clear" style={{marginBottom: "30px!important"}}></div>

                  {[commentbox]}
                  <h4 style={{display: "block",width: "100%",height: "50px",textAlign: "right",paddingRight: "40px",marginTop:"20px"}} >
                      <button className="doSubmit" onClick={()=>{showConfirm(1)}} style={{float: "right",width: "80px",height: "30px",backgroundColor: "#9864C9",borderRadius: "4px",color: "#f3f3f3",marginLeft: "60px"}}>提交</button >
                      {/* <button className="doSubmit" onClick={()=>{showConfirm(1)}} style={{float: "right",width: "80px",height: "30px",backgroundColor: "#a4080f",borderRadius: "4px",color: "#f3f3f3",marginLeft: "60px"}}>提交</button> */}
                      <span style={{height: "30px",lineHeight: "30px",display: "block",float: "right",color: "#a4080f"}}>最终得分：<b className="score" id="score">{allscore_avg}</b></span>
                      <span style={{height: "30px",lineHeight: "30px",display: "block",float: "left",paddingLeft: "30px"}}><span id="lastscore"></span></span>
                  </h4>
                </div> 
              </div>
          </div>
        )
    }
    else{
      return (
        <div key={RandomKey()}>
          <div className="hh" style={{border:"none"}}>评分</div>
            <div className="raterDiv">
              <div id="standard" style={{height:"60px",lineHeight:"60px"}}>
                未设置评审指标
              </div>
            </div>
        </div>
      )
    }
  }
  const votetemplate = (standardlist,judgetype) => {
    let standard = [];
    let commentbox = [];

    let cellwidth = Math.floor(100/standardlist.length) + '%';
    if(standardlist.length > 0){
      for(let i = 0;i < standardlist.length;i++){
        standard.push(<span style={{width:cellwidth}} key={RandomKey()}><input type="radio" onClick={()=>{score(standardlist[i].review,standardlist[i].score,2)}} name='radio' value={standardlist[i].score} />&nbsp;<b>*{standardlist[i].review}</b></span>);
      }
      if(judgetype == 4){
        commentbox.push(<div key={RandomKey()} style={{width:"100%",textAlign:"center",marginTop:"15px"}}><div style={{width:"100%",height:"30px",lineHeight:"30px",textAlign:"left",fontSize:"15px",fontWeight:"bold",marginLeft:"10px"}}>点评</div><textarea id="comment" rows="3" cols="90" style={{width:"100%"}}></textarea></div>);
      }

      return (
              <div key={RandomKey()}>
              <div className="hh" style={{border:"none"}}>投票</div>
              <div className="voteDiv">
                <div id="standard">
                {[standard]}
                </div>
              </div>
              <div className="clear" style={{marginBottom: "30px!important"}}></div>
              {[commentbox]}
              <h4 style={{display: "block",width: "100%",height: "50px",textAlign: "right",paddingRight: "40px",marginTop:"20px"}} >
              <button className="doSubmit" onClick={()=>{showConfirm(2)}} style={{float: "right",width: "80px",height: "30px",backgroundColor: "#9864C9",borderRadius: "4px",color: "#f3f3f3",marginLeft: "60px"}}>提交</button>
                {/* <button className="doSubmit" onClick={()=>{showConfirm(2)}} style={{float: "right",width: "80px",height: "30px",backgroundColor: "#a4080f",borderRadius: "4px",color: "#f3f3f3",marginLeft: "60px"}}>提交</button> */}
                <span style={{height: "30px",lineHeight: "30px",display: "block",float: "right",color: "#a4080f"}}>最终得分：<b className="score" id="score">0</b></span>
                <span style={{height: "30px",lineHeight: "30px",display: "block",float: "left",paddingLeft: "30px"}}><span id="lastscore"></span></span>
              </h4> 
              </div>
      )
    }
    else{
      return (
        <div key={RandomKey()}>
        <div className="hh" style={{border:"none"}}>投票</div>
        <div className="voteDiv">
          <div id="standard" style={{height:"60px",lineHeight:"60px"}}>
            未设置评审指标
          </div>
        </div>
        </div>
      )
    }
  }
  const caseDetail = async () =>{
    const params = new URLSearchParams(location.search);
    const id = params.get("id");
    try {
      var param = {"f":"J_caseDetail","p":{"token":getCatch("token"),"caseid":id}};
      return await getCaseDetail(param).then((res) => {
        console.log(res);
          if(res.c !== 0){
            message.error(res.m);
            return;
          }
          else{
            let ele = [];
            ele.push(<h3 key={RandomKey()} style={{width: "100%", textAlign: "center", padding: "20px 0"}}>{res.d.info.template_title}</h3>);
            ele.push(<div key={RandomKey()} id="upload" className="sanjiao-img" style={{margin:"0px",backgroundRepeat:"no-repeat",backgroundPosition:"center",backgroundSize:"contain",textAlign:"center",maxHeight:"100%",maxWidth:"100%"}}></div>);
            ele.push(<div key={RandomKey()} style={{border:"1px solid #9864C9",paddingLeft:"10px",textAlign:"left",width:"100%",background:"#9864C9",marginTop:"10px"}}><div style={{color:"#fff",fontSize:"30px",fontWeight:"bold",marginTop:"10px"}}>{res.d.info.name}</div><div style={{color:"#fff",fontSize:"20px",marginTop:"15px"}}>参赛单位: {res.d.info.showcomp}</div><div style={{color:"#fff",marginBottom:"10px",marginTop:"10px"}}>{res.d.info.symbol}</div></div>);
            // ele.push(<div key={RandomKey()} style={{border:"1px solid #a4080f",paddingLeft:"10px",textAlign:"left",width:"100%",background:"#a4080f",marginTop:"10px"}}><div style={{color:"#fff",fontSize:"30px",fontWeight:"bold",marginTop:"10px"}}>{res.d.info.name}</div><div style={{color:"#fff",fontSize:"20px",marginTop:"15px"}}>参赛单位: {res.d.info.showcomp}</div><div style={{color:"#fff",marginBottom:"10px",marginTop:"10px"}}>{res.d.info.symbol}</div></div>);
            //基本信息

            ele.push(<div key={RandomKey()} className="hh" style={{marginBottom:"20px"}}>基本信息</div>);
            let showinfo = "";
            let uploadpic = "";
            let editors = [];
            for(let i = 0;i < res.d.info.detail.base.length;i++){
              if(res.d.info.detail.base[i].name === 'showcomplogo'){
                continue;
              }                
              if(res.d.info.detail.base[i].type === 'editor'){
                ele.push(<div key={RandomKey()} style={{fontSize:"14px",fontWeight:"bold",textAlign:"left",marginTop:"20px"}}>{res.d.info.detail.base[i].title}</div>);
                ele.push(<div key={RandomKey()} id={res.d.info.detail.base[i].name} name={res.d.info.detail.base[i].name} className='offerContent' style={{overflowWrap: "break-word"}}></div>);
                editors.push({"id":res.d.info.detail.base[i].name,"value":res.d.info.detail.base[i].myvalue});
                continue;
              }
              switch(res.d.info.detail.base[i].type){
                case 'upload':
                  if(res.d.info.detail.base[i].name == 'banner'){
                    uploadpic = res.d.info.detail.base[i].myvalue;
                    continue;
                  }
                  else{
                    showinfo = '<img src="'+res.d.info.detail.base[i].myvalue+'" />';
                  }
                  break;
                case 'text':
                  showinfo = res.d.info.detail.base[i].myvalue;
                  break;
                case 'range':
                    try{
                      showinfo = (res.d.info.detail.base[i].myvalue[0]).substr(0,10) + " 至 " + (res.d.info.detail.base[i].myvalue[1]).substr(0,10);
                    }catch(e){
                      showinfo = "";
                    }
                    break;
                case 'select_custom':
                    showinfo = res.d.info.detail.base[i].myvalue;
                    break;
                case 'select_company_category':
                    showinfo = res.d.info.detail.base[i].myvalue;
                    break;
                case 'select_category':
                    showinfo = res.d.info.detail.base[i].myvalue;
                    break;
                default :
                  showinfo = "";
                  break;
              }
              if(showinfo === res.d.info.name || showinfo === res.d.info.showcomp){//已展示作品名称，跳过
                continue;
              }
              ele.push(<div key={RandomKey()} style={{textAlign:"left"}}><span className='detail_subtitle' style={{width:"120px",position:"relative",display:"table-cell",fontSize:"14px",fontWeight:"bold"}}>{res.d.info.detail.base[i].title}</span><span style={{marginLeft:"150px",position:"relative",display:"table-cell"}}><div className='detail_subcontent' style={{wordWrap:"break-word"}}>{showinfo}</div></span></div>);
            }

            //作品描述
            let info = res.d.info.detail.offer;
            ele.push(<div key={RandomKey()} className="hh">作品描述</div>);
            // editors = [];
            for(let i = 0;i < info.length;i++){
              if(info[i].type === 'editor'){
                ele.push(<div key={RandomKey()} style={{fontSize:"14px",fontWeight:"bold",textAlign:"left",marginTop:"20px"}}>{info[i].title}</div>);
                ele.push(<div key={RandomKey()} id={info[i].name} name={info[i].name} className='offerContent' style={{overflowWrap: "break-word"}}></div>);
                editors.push({"id":info[i].name,"value":info[i].myvalue});
                continue;
              }

              switch(info[i].type){
                case 'upload':
                  if(info[i].name == 'banner'){
                    uploadpic = info[i].myvalue;
                    continue;
                  }
                  else{
                    showinfo = '<img src="'+info[i].myvalue+'" />';
                  }
                  break;
                case 'text':
                  showinfo = info[i].myvalue;
                  break;
                case 'range':
                    try{
                      showinfo = (info[i].myvalue[0]).substr(0,10) + " 至 " + (info[i].myvalue[1]).substr(0,10);
                    }catch(e){
                      showinfo = "";
                    }
                    break;
                case 'select_custom':
                    showinfo = info[i].myvalue;
                    break;
                case 'select_company_category':
                    showinfo = info[i].myvalue;
                    break;
                case 'select_category':
                    showinfo = info[i].myvalue;
                    break;
                default :
                  showinfo = "";
                  break;
              }
              ele.push(<div key={RandomKey()} style={{textAlign:"left"}}><span className='detail_subtitle' style={{width:"120px",position:"relative",display:"table-cell",fontSize:"14px",fontWeight:"bold"}}>{info[i].title}</span><span style={{marginLeft:"150px",position:"relative",display:"table-cell"}}><div className='detail_subcontent' style={{wordWrap:"break-word"}}>{showinfo}</div></span></div>);
            }
            
            setCaseinfoElements([...CASEINFO, ele]);
            //设置尺寸
            setTimeout(function(){
              const viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
              let spans = document.getElementsByClassName("detail_subtitle");
              for(let i = 0;i < spans.length;i++){
                spans[i].style.width = viewportWidth*0.1 + 'px';
              }
              let contentspans = document.getElementsByClassName("detail_subcontent");
              for(let i = 0;i < contentspans.length;i++){
                contentspans[i].style.width = viewportWidth*0.5 + 'px';
              }
              
            },300);
           
            //设置评审规则数据
            ele = [];
            ele.push(
              <div key={RandomKey()} style={{textAlign:"center",background:"black",padding:"5px"}}>
              <div key={RandomKey()} style={{height:"40px",lineHeight:"40px",color:"#a4080f",fontSize:"30px",fontWeight:"bold",letterSpacing:"2px"}}>{res.d.info.template_title}</div>
              <div key={RandomKey()} style={{height:"40px",lineHeight:"40px",color:"#fff",fontSize:"25px",letterSpacing:"2px"}}>评审指标细则</div>
              </div>
            ); 
            ele.push(<Table id="standardbox" key={RandomKey()} columns={columns} dataSource={data} loading="false" showHeader={false} pagination={false} rowClassName="ant-table-row"></Table>);
            setStandardElements([...STANDARD, ele]); 

            //显示分数
            let score = JSON.stringify(res.d.scoreinfo);
            score = JSON.parse(score);
            let lastscore = "";
            if(res.d.scoretype == 1 || res.d.scoretype == 2){
              lastscore = "";

              for(let key in score){
                lastscore += key + " : " + score[key] + " ";
              }
              if(lastscore !== ""){
                lastscore = '您的上次评分是：' + lastscore;
                _JUDGED = true;
              }
              else{
                lastscore = "您还没有评分";
                _JUDGED = false;
              }
            }
            if(res.d.scoretype == 3 || res.d.scoretype == 4){
              for(let key in score){
                lastscore += key + " : " + score[key];
              }
              if(lastscore !== ""){
                lastscore = '您的上次投票是：' + lastscore;
                _JUDGED = true;
              }
              else{
                lastscore = "您还没有投票";
                _JUDGED = false;
              }
            }
            
            try{
              document.getElementById("lastscore").innerHTML = lastscore;
            }catch(e){

            }

            setTimeout(function(){
              //处理头图
              if(uploadpic !== '' && uploadpic != null){
                document.getElementById("upload").innerHTML = '<img class="bannerimg" src="'+uploadpic+'" />';
              }
              for(let i = 0;i < editors.length;i++){
                document.getElementById(editors[i].id).innerHTML = editors[i].value;
              }
              //处理附件
              //pdf
              let pdflist = [];
              if(res.d.info.detail.attach.PDF.length > 0){
                for(let i = 0;i < res.d.info.detail.attach.PDF.length;i++){
                  pdflist.push(<div key={RandomKey()} className='divPdf' onClick={()=>{view(res.d.info.detail.attach.PDF[i],"pdf")}}></div>);
                }
              }
              else{
                pdflist.push(<p key={RandomKey()} className="nopdf">无PDF文件</p>);
              }
              setPdflistElements([...PDFLIST, pdflist]);

              //video
              if(res.d.info.detail.attach.VIDEO.length > 0){
                let html = '';
                for(let i = 0;i < res.d.info.detail.attach.VIDEO.length;i++){
                  html += '<video src="'+res.d.info.detail.attach.VIDEO[i]+'" controls="controls"  width="100%"></video>';
                }
                document.getElementById("VIDEO").innerHTML = html;
              }
              else{
                document.getElementById("VIDEO").innerHTML = '<p class="nopdf">无视频文件</p>';
              }
              //pic
              if(res.d.info.detail.attach.PIC.length > 0){
                let picele = [];
                let html = [];
                let btnhtml = [];
                let btnid = '';
                let imgid = '';
                for(let i = 0;i < res.d.info.detail.attach.PIC.length;i++){
                  btnid = 'imgbtn' + i;
                  imgid = 'img' + i;
                  html.push(<img key={RandomKey()} id={imgid} src={res.d.info.detail.attach.PIC[i]} className="attach_pic" onClick={()=>{view(res.d.info.detail.attach.PIC[i],"pic")}} />);
                  btnhtml.push(<div key={RandomKey()}  id={btnid} className="attach_picbtn" onClick={()=>{goimg(i)}}>&nbsp;</div>)
                  attach_piclist.push(res.d.info.detail.attach.PIC[i]);
                }
                setPiclistElements([...PICLIST, html]);
                setPicbtnlistElements([...PICBTNLIST, btnhtml]);

                if(res.d.info.detail.attach.PIC.length > 0){
                  setTimeout(() => {
                    document.getElementById("img0").style.display = "block";
                    document.getElementById("imgbtn0").style.background = "#ccc";
                    showpic(0);
                  }, 300);
                }
              }
              else{
                document.getElementById("picbox").innerHTML = '<div class="layui-carousel" style="textAlign:center"><p class="nopdf">无图片文件</p></div>';
              }
            },300);

            // let pfele = [];
            // setPingfenElements([...PINGFEN, pfele]);
            return true;
          }
        });
    } catch (error) {
        
      return false;
    }
  }

  let picindex = 0;
  let copacity = 1;
  let hidepichandler;
  let picboxhandler;

  const view = (url,type)=>{
    var param = {"f":"J_viewAttach","p":{"token":getCatch("token"),"url":url,"type":type}};
      return viewAttach(param).then((res) => {
        window.open(res.d.url,"_blank");
        // window.open('/judge/#/view?url=' + encodeURI(res.d.url),"_blank");
      })
  }

  const goimg = (imgid)=>{
    picindex = imgid;
    clearTimeout(hidepichandler);

    try{
      for(let i = 0;i < attach_piclist.length;i++){
        if(i == picindex){
          document.getElementById("img"+i).style.display = "block";
          document.getElementById("img"+i).style.opacity = 1;
          document.getElementById("imgbtn"+i).style.background = "#ccc";
        }
        else{
          document.getElementById("img"+i).style.display = "none";
          document.getElementById("imgbtn"+i).style.background = "#fff";
        }
      }
      picindex = ((picindex+1) > (attach_piclist.length-1)) ? 0 : (picindex+1);

    }catch(e){
      
    }
  }
  const showpic = (showpicindex) => {
    if(attach_piclist.length == 0 || attach_piclist.length == 1){
      return;
    }
    clearTimeout(picboxhandler);
    clearTimeout(hidepichandler);
    copacity = 1;

    picindex = showpicindex;
    picboxhandler = setInterval(() => {
      try{
        for(let i = 0;i < attach_piclist.length;i++){
          if(i == picindex){
            document.getElementById("img"+i).style.display = "block";
            document.getElementById("img"+i).style.opacity = 1;
            document.getElementById("imgbtn"+i).style.background = "#ccc";
            // setTimeout(() => {
            //   hidepic("img"+i);
            // }, 1000);
          }
          else{
            document.getElementById("img"+i).style.display = "none";
            document.getElementById("imgbtn"+i).style.background = "#fff";
          }
        }
        picindex = ((picindex+1) > (attach_piclist.length-1)) ? 0 : (picindex+1);

      }catch(e){
        clearInterval(picboxhandler);
      }
    }, 3000);
  }
  const hidepic = (imgid) => {
    hidepichandler = setInterval(() => {
      try{
        if(copacity > 0.2){
          document.getElementById(imgid).style.opacity = copacity-0.1;
          copacity -= 0.1;
        }
        else{
          clearInterval(hidepichandler);
          copacity = 1;
          document.getElementById(imgid).style.display = "none";
        }
      }catch(e){
        clearInterval(hidepichandler);
      }
    }, 100);
  }
  window.addEventListener("visibilitychange",function(){
    // showpic(0);
    // window.location.reload();
  })

  const showconfirmbox = ()=>{
    var scroll_height = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
    var clientHeight = 0;
    var clientWidth = 0;
    if (document.body.clientHeight && document.documentElement.clientHeight) {
        // 如果同时存在 document.body.clientHeight 和 document.documentElement.clientHeight
        clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
        clientWidth = Math.min(document.body.clientWidth, document.documentElement.clientWidth);
    } else {
        // 如果其中一个不存在
        clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
        clientWidth = Math.max(document.body.clientWidth, document.documentElement.clientWidth);
    }
    document.getElementById("confirmbox").style.display = "block";
    document.getElementById("confirmbox").style.left = "0px";
    document.getElementById("confirmbox").style.top = (scroll_height - clientHeight) + 'px';
    document.getElementById("confirmbox").style.width = clientWidth + "px";
    document.getElementById("confirmbox").style.height = clientHeight + "px";

    document.body.style.overflow = "hidden";
    document.getElementById("confirmbox_content").style.top = (clientHeight/3)+'px';
    document.getElementById("confirmbox_content").style.left = (clientWidth/2 - 100)+'px';
  }
  const confirmed = ()=>{
    window.close();
  }

  return (
    <Layout className="layout" style={{display:"block"}}>
    <Header>
      <div style={{width:"70%",marginLeft:"15%"}}>
        <div style={{float:'left', width:"50%"}}>
          <div className="logo" ><img src={LOGO} alt="" width="120px" /></div>
        </div>
        <div style={{float:'right',color:"#afa178"}}>
        {LOGINNAME} / <a href='#' onClick={doLogout} ><span style={{color: "#afa178"}}>退出登录</span></a> / <a href='./#/list'><span style={{color: "#afa178"}}>返回首页</span></a>
        </div>
      </div>
    </Header>
    <Content style={{padding: '30px 50px 5px',background: "#9864C9"}}>
    {/* <Content style={{padding: '30px 50px 5px',background: "#a4080f"}}> */}
      <div style={{textAlign:"center",width: "100%",height:"150px",opacity:"0.4",marginTop:"-20px",backgroundPositionY:"top",backgroundSize:"20%"}}>
        <img src={[require("../../img/logo-04.png")]} alt="" style={{height:"90%"}} />
      </div>
      <div className="site-layout-content" style={{minHeight:scrheight-250}}>
        <div style={{width:'90%',marginLeft:'5%'}}>
          <div className="hh">{LOGINNAME} , 您好 , 欢迎为下面的作品评分！</div> 
          {/* <img src={[require("../../img/score-A.png")]} style={{width:"100%"}} />  */}
          <div style={{width:"100%"}} id="standard">
            {STANDARD}
          </div>
          <div style={{clear:"both"}}></div>

          <div className="hh">请您在了解评审标准后，开始为参赛作品评分，履行您的评委职责。</div> 
          <div>{CASEINFO}</div>
          <div className="hh">附件</div>
          <div className='hh3'>PDF</div>
          <div style={{padding: "0px 100px"}} id="PDF">{PDFLIST}</div>
          <div className="clear"></div>
          <div className="hh3">视频文件</div>
          <div style={{padding: "0px 100px"}} id="VIDEO"></div>
          <div className="clear"></div>
          <div className="hh3">图片文件</div>
          {/* <div style={{padding: "0px 100px"}}>
            <div style={{padding: "0px 0px",marginTop: "40px" ,width:"100%"}}>
              <div className="layui-carousel" id="PIC" style={{textAlign:"center"}}>
                <Slider {...settings} style={{}}>
                  {PICLIST}
                </Slider>
              </div>
            </div>
          </div> */}
          <div className="clear"></div>
          <div style={{padding: "0px 100px"}}>
            <div  id="picbox" style={{padding: "0px 0px",width:"100%"}}>
              <div id="attach_pic" style={{border:"1px solid #ccc",borderRadius:"5px",height:"500px",textAlign:"center",display:"flex",alignItems:"center",justifyContent:"center"}}>
                {PICLIST}
              </div>
              <div id="attach_picbtn" style={{textAlign:"center",height:"30px",lineHeight:"30px",width:"100%",display:"flex",alignItems:"center",justifyContent:"center"}}>
                {PICBTNLIST}
              </div>
            </div>
          </div>
          <div>{SCORESTANDARD}</div>

        </div>

        <div className="clear"></div>

        <div id='confirmbox' style={{height:'100%',width:'100%',display:"none",background:"rgba(0,0,0,0.7)",position:"absolute",zIndex:"999999"}}>
          <div id='confirmbox_content' style={{height:"120px",width:"220px",background:"#e9e9e9",position:"absolute",zIndex:"9999999",borderRadius:"4px"}}>
            <div style={{height:"20px"}}>&nbsp;</div>
            <div style={{width:'100%',height:"30px"}}>评分成功</div>
            <div style={{height:"20px"}}>&nbsp;</div>
            <div style={{width:'100%'}}><button onClick={()=>{confirmed()}} style={{width:"90px",height:"30px",backgroundColor: "#a4080f",borderRadius: "4px",color: "#f3f3f3"}}>关闭页面</button></div>
          </div>
        </div>
    </div>
    </Content>
    <Footer style={{clear:"both",backgroundColor: "white",paddingTop: "30px",height: "115px"}}>
    {/* <p className="copyright">联系方式:021-61150705、021-61150706</p> */}
    {/* <p className="copyright">case2019@topdigitalworld.com</p> */}
    <p className="copyright">Copyright © 上海优天网络科技有限公司</p>
    </Footer>
  </Layout>
  );
}

export default Detail;